import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {  ObtenerClientesSocioEnAPI } from "../../action/actionCreatorsRequests"
import { traducirPagina, efectoRemoveBuscadorReferencia, obtenerUsuario } from '../../librerias/funciones'
import { MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBBtn } from 'mdbreact';
import FichaMasiva from '../../components/FichaMasiva';
import MantenimientoClienteTaller from './MantenimientoClienteTaller'
import {
    PlusOutlined,
    CloseOutlined,
    SearchOutlined,
    EditOutlined,
    DeleteOutlined,
    ArrowDownOutlined,
    CloudUploadOutlined
} from '@ant-design/icons';

import { Select, Card, Modal, Button, Input, Row, Col, Drawer } from 'antd';

const { Option } = Select;
const FichaSeleccionCliente = ({ props, configApp, openDrawerFichaClienteSocio, clienteTallerSeleccionado }) => {
    const [abrirFichaClienteTaller, setAbrirFichaClienteTaller] = React.useState(false);
    const [mostrarBotones, setMostrarBotones] = React.useState([]);

    const [abrirFichaMasiva, setAbrirFichaMasiva] = React.useState(false);

    const [hayClientes, setHayClientes] = React.useState(false);
    const [clientesTaller, setClientesTaller] = React.useState([]);
    const [obtenerClientesAux, setObtenerClientesAux] = React.useState([]);
    const [actualizarClientes, setActualizarClientes] = React.useState(false);
    const [textoFiltroCliente, setTextoFiltroCliente] = React.useState("");
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = React.useState({});
    const [idSocioLocal, setIdSocioLocal] = React.useState(0);




    const BuscarClientes = (ID_SOCIO, ID_TIENDA_RETAIL, ID_TIPO_INTEGRACION) => {
        setHayClientes(true);
        ObtenerClientesSocioEnAPI(ID_SOCIO, ID_TIENDA_RETAIL, ID_TIPO_INTEGRACION).then((cli) => {
            if (cli !== undefined) {
                if (cli !== null && cli.length > 0) {
                    setClientesTaller(cli)
                    setObtenerClientesAux(cli)
                } else {
                    setClientesTaller(null)
                    setObtenerClientesAux(null)

                }
            }
        })
    }


    const actualizarTabla = () => {
        BuscarClientes(props.ID_SOCIO, props.ID_TIENDA_RETAIL, props.ID_TIPO_INTEGRACION);

    }


    if (!hayClientes && props.ABRIR_FICHA) {
        setHayClientes(true);
        BuscarClientes(props.ID_SOCIO, props.ID_TIENDA_RETAIL, props.ID_TIPO_INTEGRACION);


        let LISTA_SOCIOS = obtenerUsuario().SOCIOS;
        if (LISTA_SOCIOS !== undefined && LISTA_SOCIOS !== null) {
            let REGISTRO = LISTA_SOCIOS.find((registro) => registro.ID_SOCIO === props.ID_SOCIO)
            if (REGISTRO !== undefined) {
                if (REGISTRO.CONECTADO)
                    setMostrarBotones(REGISTRO.CONECTADO ? false : true)
            } else {
                setMostrarBotones(false)
            }
        }

        console.log("inpec", props.ID_TIENDA_RETAIL)


        if (props.ID_TIENDA_RETAIL > 0) {
            setMostrarBotones(false)
        }

    } else {
        if (!props.ABRIR_FICHA && hayClientes) {


            setIdSocioLocal(0)
            setClienteSeleccionado({})
            setSociosLocal([])
            setTextoFiltroCliente("")
            setHayClientes(false);
            setClientesTaller([])
            setObtenerClientesAux([])
        }
    }



    const ordenarTablaCliente = (ID, ORDERCOLUM, ORDERDIR) => {
        /*
        getClienteTallerEnAPI(ID, ORDERCOLUM, ORDERDIR).then((cli) => {
            if (cli.CLIENTES !== null) {
                setClientesTaller(cli.CLIENTES)
                setObtenerClientesAux(cli.CLIENTES)
                if (textoFiltroCliente.trim() !== "") {
                    buscarCliente(textoFiltroCliente, cli.CLIENTES);
                }

            }
        })
        */
    }




    const buscarCliente = (palabra, listaCliente) => {
        let clientesEncontrado = [];
        if (palabra !== "") {
            if (listaCliente !== null) {
                listaCliente.find(function (cliente, i) {


                    if (cliente.Codigo.toLowerCase().includes(palabra.toLowerCase())) {
                        let existeCliente = clientesEncontrado.find(cli => cli.Codigo === cliente.Codigo)
                        if (existeCliente === undefined) {
                            clientesEncontrado.push(cliente)
                        }
                    }

                    if (cliente.Razon.toLowerCase().includes(palabra.toLowerCase())) {
                        let existeCliente = clientesEncontrado.find(cli => cli.Codigo === cliente.Codigo)
                        if (existeCliente === undefined) {
                            clientesEncontrado.push(cliente)
                        }
                    }

                    if (cliente.Cif.toLowerCase().includes(palabra.toLowerCase())) {
                        let existeCliente = clientesEncontrado.find(cli => cli.Codigo === cliente.Codigo)
                        if (existeCliente === undefined) {
                            clientesEncontrado.push(cliente)
                        }
                    }

                    if (cliente.Poblacion.toLowerCase().includes(palabra.toLowerCase())) {
                        let existeCliente = clientesEncontrado.find(cli => cli.Codigo === cliente.Codigo)
                        if (existeCliente === undefined) {
                            clientesEncontrado.push(cliente)
                        }

                    }

                    if (cliente.Telefono.toLowerCase().includes(palabra.toLowerCase())) {
                        let existeCliente = clientesEncontrado.find(cli => cli.Codigo === cliente.Codigo)
                        if (existeCliente === undefined) {
                            clientesEncontrado.push(cliente)
                        }
                    }

                })
            }
            if (clientesEncontrado.length > 0) {
                setClientesTaller(clientesEncontrado);
            } else {
                setClientesTaller(null);
            }
        } else {
            setClientesTaller(obtenerClientesAux);
        }
    }


    return (
        <div>


            <Drawer
                width={ 1300}
                onClose={() => { props.ACTUALIZAR_FICHA(false) }}
                closable={false}
                visible={props.ABRIR_FICHA}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>



                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {   props.ACTUALIZAR_FICHA(false) }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>


                


                <div className="p-3" style={{ height: (configApp.height - 70).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>
                    <div className="flex-container mdb-skin">
                        <div style={{ flexGrow: '6', textAlign: 'left' }}>
                            <div className="grid-container mb-3" style={{ backgroundColor: '#eee' }}>
                                <div className="grid-item">
                                    <input id="buscadorClienteTaller" className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Buscar_cliente")} style={{ backgroundColor: "transparent", width: '400px', border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" value={textoFiltroCliente} onChange={(e) => { setTextoFiltroCliente(e.target.value); buscarCliente(e.target.value, obtenerClientesAux) }} />
                                </div>

                                <div className="grid-item" >
                                    <MDBBtn id="closeBuscadorClienteTaller" onClick={e => { efectoRemoveBuscadorReferencia("buscadorCliente", true); }} style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: 'hidden' }} className="btn-matriculav2">  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                </div>

                                <div className="grid-item barraLateral" ></div>

                                <div className="grid-item">
                                    <MDBBtn style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                </div>
                            </div>
                        </div>


                        {mostrarBotones ?
                            <>
                                <div >
                                    <button style={{ height: '40px', width: '150px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', backgroundColor: 'efefef', cursor: 'pointer' }} onClick={() => {
                                        setAbrirFichaMasiva(true)
                                    }

                                    }><CloudUploadOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Masiva")} </span>  </button>
                                </div>


                                <div >
                                    <button style={{ height: '40px', width: '180px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', backgroundColor: '#efefef', cursor: 'pointer' }} onClick={() => {
                                        setClienteSeleccionado({});
                                        //store.dispatch(DrawerFichaMantenimientoClienteTaller(true));

                                        setAbrirFichaClienteTaller(true)
                                    }

                                    }><PlusOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Nuevo_Cliente")} </span>  </button>
                                </div>
                            </>
                            :
                            null
                        }

                    </div>

                    <Card style={{ height: (configApp.height - 170).toString() + "px" }} className="mb-2 mdb-skin" >
                        {clientesTaller === null ?
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Socio_seleccionado")}</h4>
                            </div>
                            :
                            clientesTaller.length > 0 ?
                                <div style={{ fontSize: '16px', fontWeight: '500', color: "#000", height: (configApp.height - 225).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }} className="row">
                                    <MDBTable responsive hover >
                                        <MDBTableHead>
                                            <tr>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '110px', verticalAlign: 'baseline', cursor: 'pointer' }} >
                                                    {traducirPagina("Codigo")}
                                                </th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', cursor: 'pointer' }} >{traducirPagina("Razon")}  </th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '110px', verticalAlign: 'baseline', cursor: 'pointer' }}>{"CIF"} </th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '200px', verticalAlign: 'baseline' }}>{traducirPagina("Poblacion")}</th>
                                                <th style={{ paddingLeft: 0, fontSize: "14px", fontWeight: "bold", width: '200px', verticalAlign: 'baseline' }}>{traducirPagina("Telefono")}</th>
                                            </tr>
                                        </MDBTableHead>
                                        <MDBTableBody>
                                            {clientesTaller.map((cliente, i) =>
                                                <tr key={cliente.Codigo} onClick={(e) => {
                                                    if (props.ID_TIENDA_RETAIL > 0) {
                                                        const { CODIGO_CLIENTE_SOCIO, ID_TIPO_INTEGRACION, NOMBRE, ID } = props.DATOS_TIENDA

                                                        cliente.NOMBRE_TIENDA_RETAIL = NOMBRE
                                                        cliente.ID_TIENDA_RETAIL = ID
                                                        cliente.ID_TIPO_INTEGRACION = ID_TIPO_INTEGRACION

                                                        cliente.CODIGO_CLIENTE_SOCIO = CODIGO_CLIENTE_SOCIO

                                                    }

                                                    //props.CLIENTE_SELECT(cliente)
                                                    props.DATOS_CLIENTE_SELECCIONADO(cliente)
                                                    props.ABRIR_FICHA_MANTENIMIENTO(true)
                                                    props.ACTUALIZAR_FICHA(false)
                                                }}>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Codigo}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Razon}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Cif}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Poblacion}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }}>{cliente.Telefono}</td>

                                                </tr>
                                            )}
                                        </MDBTableBody>
                                    </MDBTable>
                                </div>

                                :
                                <div style={{ fontSize: '16px', fontWeight: '500', color: "#000" }} className="row">
                                    <MDBCol md="9">
                                        <div>
                                            <span className="skeleton-box" style={{ width: '900px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '900px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                        </div>
                                    </MDBCol>
                                </div>
                        }
                    </Card>
                </div>
            </Drawer>

            {abrirFichaClienteTaller ?

                <MantenimientoClienteTaller
                    ABRIR_FICHA={abrirFichaClienteTaller}
                    CERRAR_FICHA={setAbrirFichaClienteTaller}

                    CLIENTE_SELECCIONADO={clienteSeleccionado}
                    ACTUALIZAR_CLIENTES={null}
                    ID_SOCIO={props.ID_SOCIO}
                    ACTUALIZAR_SECUNDARIO={actualizarTabla}
                > </MantenimientoClienteTaller>
                :
                null
            }



            {abrirFichaMasiva ?
                <FichaMasiva
                    title={traducirPagina("titulo_masiva")}
                    ABRIR_FICHA={abrirFichaMasiva}
                    ACTUALIZAR_MASIVA={setAbrirFichaMasiva}
                    ID_SOCIO={props.ID_SOCIO}
                    ACTUALIZAR_CLIENTES={null}
                    ACTUALIZAR_SECUNDARIO={actualizarTabla}

                ></FichaMasiva>
                :
                null
            }

        </div>
    )
}

FichaSeleccionCliente.propTypes = {
    title: PropTypes.string,
    ID_SOCIO: PropTypes.number,
    ABRIR_FICHA: PropTypes.bool,
    ACTUALIZAR_FICHA: PropTypes.func,
    CLIENTE_SELECT: PropTypes.func,
    ABRIR_FICHA_MANTENIMIENTO: PropTypes.func,
    DATOS_CLIENTE_SELECCIONADO: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado
    };
}

export default connect(mapStateToProps)(FichaSeleccionCliente);